import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import firebase from "firebase";
import "firebase/firestore";
// Add the Performance Monitoring library
import "firebase/performance";
// import VueFire from 'vuefire'
import VModal from "vue-js-modal";
import Router from "vue-router";

Vue.config.productionTip = false;

// Vue.use(VueFire);
Vue.use(VueAxios, axios);
Vue.use(VModal);

var config = {
  apiKey: "AIzaSyCef6q8e5INGo41J0kDUCWKQq9bzFg7GX4",
  authDomain: "appskeletons.firebaseapp.com",
  projectId: "appskeletons"
};

firebase.initializeApp(config);
export const firebaseDb = firebase.firestore();
export default firebaseDb;

const perf = firebase.performance();

var app = new Vue({
  data: { loading: true, hasUser: false },
  store,
  render: function(h) {
    return h(App);
  }
}).$mount("#app");

firebase.auth().onAuthStateChanged(user => {
  if (user != null) {
    console.log(`SET USER VERIFIED: ${user.emailVerified}`);
    store.state.userVerified = user.emailVerified;
  } else {
    store.state.userVerified = false;
  }

  if (app.loading) {
    Vue.use(Router);
  }

  var hasUser = user != null;

  store.state.navigationBarState = 1;

  store.dispatch("fetchUserApps", user);

  app = new Vue({
    data: {
      loading: false,
      hasUser: hasUser
    },
    router,
    store,
    render: function(h) {
      return h(App);
    }
  }).$mount("#app");
});
